const genSafeId = (prefix = 'fbnb2b'): string => {
  // @ts-ignore
  genSafeId.counter ??= 0

  // @ts-ignore
  return `${prefix}-${genSafeId.counter++}`
}

export class ListenError extends Error {
  constructor(message: string, readonly data: unknown) { super(message) }
}

export const listen = async <T = unknown>(id?: string, timeout?: number): Promise<T> => {
  type EventData = {
    status: 'success' | 'failed'
    fbn_res_id: string
    data: unknown
    msg?: string
  }

  return new Promise((resolve, reject) => {
    const listener = (e: MessageEvent<EventData>) => {
      if (!e.data.fbn_res_id) {
        return
      }

      if (!(!id || id === e.data.fbn_res_id)) {
        return
      }

      window.removeEventListener('message', listener)

      timer && clearTimeout(timer)

      if (e.data.status === 'failed') {
        return reject(new ListenError(e.data.msg ?? 'Unknown Error', e.data.data))
      }

      resolve(e.data.data as T)
    }

    const timer = !timeout ? undefined : setTimeout(() => {
      window.removeEventListener('message', listener)
      reject(new ListenError('Timeout', undefined))
    }, timeout)

    window.addEventListener('message', listener)
  })
}

export type ActionOpt = {
  action: string
  args: unknown[]
  timeout?: number
}

export const action = async <T>(source: Window, opt: ActionOpt) => {
  const id = genSafeId()
  const promise = listen<T>(id, opt.timeout)

  source.postMessage({
    fbn_req_id: id,
    action: opt.action,
    args: opt.args
  }, '*')

  return await promise
}

/**
 * Skip waiting for reply
 */
action.silent = (source: Window, opt: Omit<ActionOpt, 'timeout'>) => {
  source.postMessage({
    fbn_req_id: Math.random().toString(),
    action: opt.action,
    args: opt.args
  }, '*')
}
